/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { termsControllerActivate } from '../fn/terms/terms-controller-activate';
import { TermsControllerActivate$Params } from '../fn/terms/terms-controller-activate';
import { termsControllerCreate } from '../fn/terms/terms-controller-create';
import { TermsControllerCreate$Params } from '../fn/terms/terms-controller-create';
import { termsControllerDelete } from '../fn/terms/terms-controller-delete';
import { TermsControllerDelete$Params } from '../fn/terms/terms-controller-delete';
import { termsControllerGetActiveAll } from '../fn/terms/terms-controller-get-active-all';
import { TermsControllerGetActiveAll$Params } from '../fn/terms/terms-controller-get-active-all';
import { termsControllerGetActiveByType } from '../fn/terms/terms-controller-get-active-by-type';
import { TermsControllerGetActiveByType$Params } from '../fn/terms/terms-controller-get-active-by-type';
import { termsControllerGetByTypeAndVersion } from '../fn/terms/terms-controller-get-by-type-and-version';
import { TermsControllerGetByTypeAndVersion$Params } from '../fn/terms/terms-controller-get-by-type-and-version';
import { termsControllerGetHistoryByType } from '../fn/terms/terms-controller-get-history-by-type';
import { TermsControllerGetHistoryByType$Params } from '../fn/terms/terms-controller-get-history-by-type';
import { termsControllerUpdate } from '../fn/terms/terms-controller-update';
import { TermsControllerUpdate$Params } from '../fn/terms/terms-controller-update';
import { TermsDto } from '../models/terms-dto';

@Injectable({ providedIn: 'root' })
export class TermsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `termsControllerGetActiveAll()` */
  static readonly TermsControllerGetActiveAllPath = '/api/terms';

  /**
   * 활성화된 모든 약관 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `termsControllerGetActiveAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  termsControllerGetActiveAll$Response(params?: TermsControllerGetActiveAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TermsDto>>> {
    const obs = termsControllerGetActiveAll(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 활성화된 모든 약관 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `termsControllerGetActiveAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  termsControllerGetActiveAll(params?: TermsControllerGetActiveAll$Params, context?: HttpContext): Observable<Array<TermsDto>> {
    const resp = this.termsControllerGetActiveAll$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<TermsDto>>): Array<TermsDto> => r.body)
    );
  }

  /** Path part for operation `termsControllerCreate()` */
  static readonly TermsControllerCreatePath = '/api/terms';

  /**
   * 새 버전 약관 등록.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `termsControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  termsControllerCreate$Response(params: TermsControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<TermsDto>> {
    const obs = termsControllerCreate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 새 버전 약관 등록.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `termsControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  termsControllerCreate(params: TermsControllerCreate$Params, context?: HttpContext): Observable<TermsDto> {
    const resp = this.termsControllerCreate$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<TermsDto>): TermsDto => r.body)
    );
  }

  /** Path part for operation `termsControllerGetActiveByType()` */
  static readonly TermsControllerGetActiveByTypePath = '/api/terms/{type}';

  /**
   * 특정 유형의 활성 약관 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `termsControllerGetActiveByType()` instead.
   *
   * This method doesn't expect any request body.
   */
  termsControllerGetActiveByType$Response(params: TermsControllerGetActiveByType$Params, context?: HttpContext): Observable<StrictHttpResponse<TermsDto>> {
    const obs = termsControllerGetActiveByType(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 특정 유형의 활성 약관 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `termsControllerGetActiveByType$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  termsControllerGetActiveByType(params: TermsControllerGetActiveByType$Params, context?: HttpContext): Observable<TermsDto> {
    const resp = this.termsControllerGetActiveByType$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<TermsDto>): TermsDto => r.body)
    );
  }

  /** Path part for operation `termsControllerGetHistoryByType()` */
  static readonly TermsControllerGetHistoryByTypePath = '/api/terms/{type}/history';

  /**
   * 특정 유형의 약관 버전 이력 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `termsControllerGetHistoryByType()` instead.
   *
   * This method doesn't expect any request body.
   */
  termsControllerGetHistoryByType$Response(params: TermsControllerGetHistoryByType$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TermsDto>>> {
    const obs = termsControllerGetHistoryByType(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 특정 유형의 약관 버전 이력 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `termsControllerGetHistoryByType$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  termsControllerGetHistoryByType(params: TermsControllerGetHistoryByType$Params, context?: HttpContext): Observable<Array<TermsDto>> {
    const resp = this.termsControllerGetHistoryByType$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<TermsDto>>): Array<TermsDto> => r.body)
    );
  }

  /** Path part for operation `termsControllerGetByTypeAndVersion()` */
  static readonly TermsControllerGetByTypeAndVersionPath = '/api/terms/{type}/version/{version}';

  /**
   * 특정 버전 약관 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `termsControllerGetByTypeAndVersion()` instead.
   *
   * This method doesn't expect any request body.
   */
  termsControllerGetByTypeAndVersion$Response(params: TermsControllerGetByTypeAndVersion$Params, context?: HttpContext): Observable<StrictHttpResponse<TermsDto>> {
    const obs = termsControllerGetByTypeAndVersion(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 특정 버전 약관 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `termsControllerGetByTypeAndVersion$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  termsControllerGetByTypeAndVersion(params: TermsControllerGetByTypeAndVersion$Params, context?: HttpContext): Observable<TermsDto> {
    const resp = this.termsControllerGetByTypeAndVersion$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<TermsDto>): TermsDto => r.body)
    );
  }

  /** Path part for operation `termsControllerActivate()` */
  static readonly TermsControllerActivatePath = '/api/terms/{id}/activate';

  /**
   * 약관 활성화.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `termsControllerActivate()` instead.
   *
   * This method doesn't expect any request body.
   */
  termsControllerActivate$Response(params: TermsControllerActivate$Params, context?: HttpContext): Observable<StrictHttpResponse<TermsDto>> {
    const obs = termsControllerActivate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 약관 활성화.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `termsControllerActivate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  termsControllerActivate(params: TermsControllerActivate$Params, context?: HttpContext): Observable<TermsDto> {
    const resp = this.termsControllerActivate$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<TermsDto>): TermsDto => r.body)
    );
  }

  /** Path part for operation `termsControllerDelete()` */
  static readonly TermsControllerDeletePath = '/api/terms/{id}';

  /**
   * 약관 삭제.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `termsControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  termsControllerDelete$Response(params: TermsControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    const obs = termsControllerDelete(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 약관 삭제.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `termsControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  termsControllerDelete(params: TermsControllerDelete$Params, context?: HttpContext): Observable<boolean> {
    const resp = this.termsControllerDelete$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `termsControllerUpdate()` */
  static readonly TermsControllerUpdatePath = '/api/terms/{id}';

  /**
   * 약관 수정.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `termsControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  termsControllerUpdate$Response(params: TermsControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<TermsDto>> {
    const obs = termsControllerUpdate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 약관 수정.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `termsControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  termsControllerUpdate(params: TermsControllerUpdate$Params, context?: HttpContext): Observable<TermsDto> {
    const resp = this.termsControllerUpdate$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<TermsDto>): TermsDto => r.body)
    );
  }

}
